import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import type { TBankAccount } from '@shared/types/bank-account';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

export const editBankLogo = async ({
  id,
  formData,
}: {
  id: number;
  formData: FormData;
}): Promise<TBankAccount> => {
  return await request({
    url: `bank-accounts/${id}/`,
    method: 'PATCH',
    body: formData,
  });
};

export const useEditBankLogo = () => {
  return useMutation({
    mutationFn: editBankLogo,
    onError: (error: string) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success('Logo has updated successfully.');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getBankInfo],
      });
    },
  });
};
